var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection04CoachMark = function SvgSection04CoachMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.868,
    height: 15.746,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.525 4.934a1 1 0 0 1 .248 1.179L9.057 14.02c-1.095 2.332-4.427 2.29-5.462-.07L.085 5.95a1 1 0 0 1 .277-1.172L5.856.23A1 1 0 0 1 7.15.246l5.374 4.688Z",
    fill: "#EEF5FD"
  })));
};
export default SvgSection04CoachMark;